<template>
    <div class="gmf-quest-highlight-slide">
        <Quest v-if="quest" :quest="quest" />
    </div>
</template>

<style>
.gmf-quest-highlight-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.gmf-quest-highlight-slide .gmf-quest {
    width: 100%;
    max-width: 400px;
}
</style>

<script>
import Quest from '@/components/QuestList/Quest.vue';

export default {
    name: 'QuestHighlightSlide',
    components: {
        Quest,
    },
    props: {
        quest: Object,
    },
};
</script>